export default Object.freeze({
  visit: 1,
  appointment: 2,
  consulting: 3,
  educational: 8,
});
